mutation ConnectBunnyByAccount($input: ConnectBunnyByAccountInput!) {
  connectBunnyByAccount(input: $input) {
    id
    bunnySettings {
      libraryId
      cdnHostname
      apiKeyMask
      connectedAt
    }
  }
}
